import axios from 'axios';

const BASE_URL = '/api/billing-reconciliation';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);
const requestConfig = (params = {}, signal = undefined) => ({
  params: cleanParams(params),
  ...(signal ? { signal } : {}),
});

const encoded = (value) => encodeURIComponent(String(value));

export const getBillingReconciliationBacContext = async ({ runId, bac, signal, ...params } = {}) => {
  if (!runId || !bac) return null;
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/bac-context/${encoded(bac)}`, requestConfig(params, signal));
  return data;
};

export const getBillingReconciliationOperatorContext = async ({ runId, bac, signal, ...params } = {}) => {
  if (!runId || !bac) return null;
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/operator-context/${encoded(bac)}`, requestConfig(params, signal));
  return data;
};

export const getBillingReconciliationBacContextBatch = async ({ runId, bacs = [], signal, ...restPayload } = {}) => {
  if (!runId || !Array.isArray(bacs) || !bacs.length) return { contexts: [], errors: [], skipped: [], returned: 0 };
  const payload = cleanParams({
    ...restPayload,
    bacs,
  });
  const { data } = signal
    ? await axios.post(`${BASE_URL}/runs/${encoded(runId)}/bac-contexts`, payload, { signal })
    : await axios.post(`${BASE_URL}/runs/${encoded(runId)}/bac-contexts`, payload);
  return data;
};

export const getBillingReconciliationContextWarmStatus = async ({ runId, signal, ...params } = {}) => {
  if (!runId) return null;
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/context-warm/status`, requestConfig(params, signal));
  return data;
};

export const getBillingReconciliationContextWarmSchemaHealth = async () => {
  const { data } = await axios.get(`${BASE_URL}/context-warm/schema-health`);
  return data;
};

export const queueBillingReconciliationContextWarm = async ({ runId, ...payload } = {}) => {
  if (!runId) return null;
  const { data } = await axios.post(`${BASE_URL}/runs/${encoded(runId)}/context-warm`, cleanParams(payload));
  return data;
};

export const refreshBillingReconciliationBacContext = async ({ runId, bac, ...payload } = {}) => {
  if (!runId || !bac) return null;
  const { data } = await axios.post(
    `${BASE_URL}/runs/${encoded(runId)}/bac-context/${encoded(bac)}/refresh`,
    cleanParams(payload),
  );
  return data;
};
